export default __webpack_public_path__ + "static/healthCare-eba831b66d093b65d177028f142a3fde.png";